import React from 'react'
import resume from '../../assets/tejas-patne-resume.pdf'

const CTA = () => {
  return (
    <div className="cta">
        <a href={resume} download="tejas-patne-resume.pdf" className='btn'>Download Resume</a>
        <a href="#contact" className='btn btn-primary'>Let's talk</a>
    </div>
  )
}

export default CTA